import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class SalesforceLiveAgentMessageRecord extends BaseMessageRecord({
  type: "salesforce_live_agent",

  /** @memberof SalesforceLiveAgentMessageRecord# */
  chatButtonId: null,

  /** @memberof SalesforceLiveAgentMessageRecord# */
  customVariableMapping: Immutable.List([
    Immutable.Map({
      salesforceFieldName: "",
      variableName: "",
      type: "_variable_id"
    })
  ]),

  /** @memberof SalesforceLiveAgentMessageRecord# */
  enableCase: true,

  /** @memberof SalesforceLiveAgentMessageRecord# */
  enableContact: true,

  /** @memberof SalesforceLiveAgentMessageRecord# */
  fallbackResponseId: null,

  /** @memberof SalesforceLiveAgentMessageRecord# */
  tags: ""
}) {
  static getInvalidFields = () => Immutable.List()
}

export default SalesforceLiveAgentMessageRecord;
